import React__default from 'react';

var Triangle6 = function Triangle6(props) {
  var className = props.className,
    style = props.style;
  return /*#__PURE__*/React__default.createElement("svg", {
    className: className,
    style: style,
    width: "16",
    height: "18",
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("g", {
    style: {
      mixBlendMode: 'multiply'
    }
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M0 16.6794V1.32061C0.000794871 1.0896 0.0613516 0.862808 0.175665 0.662731C0.289978 0.462654 0.454076 0.296242 0.651686 0.179997C0.849295 0.0637528 1.07355 0.0017146 1.30221 3.50341e-05C1.53088 -0.00164453 1.756 0.0570929 1.95526 0.170422L15.3389 7.85294C15.5396 7.96804 15.7066 8.13483 15.8227 8.33633C15.9388 8.53783 16 8.76683 16 9C16 9.23317 15.9388 9.46217 15.8227 9.66367C15.7066 9.86517 15.5396 10.032 15.3389 10.1471L1.95526 17.8296C1.756 17.9429 1.53088 18.0016 1.30221 18C1.07355 17.9983 0.849295 17.9362 0.651686 17.82C0.454076 17.7038 0.289978 17.5373 0.175665 17.3373C0.0613516 17.1372 0.000794871 16.9104 0 16.6794H0Z",
    fill: "#4871F0"
  })));
};
Triangle6.defaultProps = {
  className: undefined,
  style: undefined
};
var Triangle6$1 = Triangle6;

export { Triangle6$1 as default };
